import React from 'react'
import { Box, Display, FlexDirection, Color, Text, FontWeight } from '@gousto-internal/citrus-react'
import { Recipe, RecipeUUID } from '@library/menu-service'
import { RecipeItem } from './RecipeItem'

type RecipesProps = {
  basketRecipes: {
    recipe: Recipe
    quantity: number
  }[]
  numberOfRecipesInBasket: number
  numPortions: number
  addRecipe: (id: RecipeUUID, view: string) => void
  removeRecipe: (recipe: Recipe) => void
  onClickRecipe: (id: RecipeUUID) => void
}

export const Recipes = ({
  basketRecipes,
  numberOfRecipesInBasket,
  numPortions,
  addRecipe,
  removeRecipe,
  onClickRecipe,
}: RecipesProps) => {
  return (
    <Box
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      width="100%"
      height="100%"
      gap={4}
      data-testid="recipes"
    >
      <Box display={Display.Flex} gap={1} color={Color.ColdGrey_900}>
        <Text fontWeight={FontWeight.Bold}>Recipes ({numberOfRecipesInBasket})</Text>
      </Box>
      {basketRecipes.map(({ recipe, quantity }, index) => (
        <RecipeItem
          key={recipe?.id}
          recipe={recipe}
          removeRecipe={removeRecipe}
          addRecipe={addRecipe}
          onClickRecipe={onClickRecipe}
          quantity={quantity}
          numPortions={numPortions}
          dataNoCode={{
            name: `orderSummaryRecipeName-${index}`,
            servings: `orderSummaryRecipeServings-${index}`,
            add: `orderSummaryRecipeAdd-${index}`,
          }}
        />
      ))}
    </Box>
  )
}
